import youtubeChannelApi from 'services/api/youtubeChannel';
import { WhiteListedChannel, InputForm } from './components';
import { StyledSkeleton } from './styled';

const FormContainer = () => {
  const { data, isFetching } = youtubeChannelApi.useGetChannelsQuery();

  if (isFetching) {
    return <StyledSkeleton variant="rounded" />;
  }

  if (data && data.length > 0) {
    return <WhiteListedChannel url={data[0].url} status={data?.[0]?.status} />;
  }

  return <InputForm />;
};

export default FormContainer;
